import { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import DashboardContext from "../../../Context";
import InputControl from "../../../components/inputs/InputControl";
import InputControlAsyncMultiBulk from "../../../components/inputs/InputControlAsyncMultiBulk";
import Axios from "axios";
import InputControlAsync from "../../../components/inputs/InputControlAsync";
import toaster from "helper/toaster";

export default function BlacklistCustomer() {
  const {
    handelFromTabel,
    urldashboard,
    sideBardata,
    authentication,
    showEditOrder,
    handelEditOrder,
    handeldmicro,
    showformmicro,
    setOnSearchLoading,
    setOffSearchLoding,
    searchLoading,
  } = useContext(DashboardContext);

  const [arryactions, setArryactions] = useState([]);

  const [isShowForm, setIsShowForm] = useState(false);

  const [userId, setUserId] = useState(0);

  const [workerIds, setWorkerIds] = useState([]);

  const [dataFrom, setDataFrom] = useState({
    userId: JSON.parse(sessionStorage.getItem("customerid")),
  });

  useEffect(() => {
    handelFromTabel({
      userId: JSON.parse(sessionStorage.getItem("customerid")),
    });

    if (sideBardata) {
      sideBardata.map((item) => {
        item.controllers.filter((find) => {
          if (`/${find.controller}` === "/Order") {
            setArryactions(find.actions);
            return find;
          }
        });
      });
    }
    return () => {};
  }, []);

  const fetchBlacklistFromAddress = async (addressId) => {
    try {
      const res = await Axios.get(
        `${urldashboard}/customer/getBlackListWorkers/${dataFrom.userId}/${addressId}`,
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await res.data.data;

      setWorkerIds(data);

      // setDataFech(data)
      // handelworkername(data.fullName)
    } catch (error) {
      //handelerrors(error)
    }
  };

  const handelValue = (name, value) => {
    switch (name) {
      case "addressId":
        fetchBlacklistFromAddress(value);
        setWorkerIds([]);
        setDataFrom({ ...dataFrom, addressId: value });
        break;

      case "blackListWorkerIds":
        if (value.length === 0) {
          setWorkerIds([]);
        }

        setDataFrom({ ...dataFrom, blackListWorkerIds: value });
        break;
      default:
        break;
    }
  };

  const handelSubmit = async (event) => {
    event.preventDefault();
    setOnSearchLoading();

    var dataForm = {
      blackListWorkerIds:
        dataFrom.blackListWorkerIds !== undefined
          ? dataFrom.blackListWorkerIds
          : workerIds.map((x) => x.value),
      addressId: dataFrom.addressId,
      userId: dataFrom.userId,
    };

    try {
      const res = await Axios.post(
        `${urldashboard}/customer/SetBlackListWorkers`,
        JSON.stringify(dataForm),
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json",
          },
        }
      );

      setOffSearchLoding();
      toaster.success(res?.data?.message);
    } catch (error) {
      //handelerrors(error)
    }

    handelFromTabel(dataFrom);
  };

  return (
    <>
      <Form>
        <Form.Row>
          <Col lg='6' md='3' sm='12' xs='12'>
            <InputControl
              url={`/userManagement/addressdropdown/${JSON.parse(
                sessionStorage.getItem("customerid")
              )}`}
              label='آدرس های مشتری'
              name='addressId'
              handelValue={handelValue}
              defaultValue={0}
            />
          </Col>

          <Col>
            <InputControlAsyncMultiBulk
              url='/worker/bulksearch'
              label='لیست نیروها'
              name='blackListWorkerIds'
              isDefaultValue={true}
              idSelect={workerIds}
              handelValue={handelValue}
              defaultValue={workerIds}
            />
          </Col>
        </Form.Row>
        <Form.Row>
          <Col className='d-flex'>
            <Button onClick={handelSubmit} variant='success'>
              {searchLoading ? (
                <i className='fa fa-spinner fa-pulse fa-fw'></i>
              ) : (
                "ذخیره"
              )}
            </Button>
          </Col>
        </Form.Row>
      </Form>
    </>
  );
}
